module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['EntityManager']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module EntityManager URL not available') },
        init: (arg) => { throw new Error('Module EntityManager URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['EntityManager'].get(request),
      init: (arg) => {
        try {
          return window['EntityManager'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: EntityManager')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module EntityManager not available') },
      init: (arg) => { throw new Error('Module EntityManager not available') }
    })
    document.head.appendChild(script);
  });